import { LoadingButton } from "@mui/lab";

export default function GetDiscountCard({
  buttonText,
  emailLink,
  remainingAmount,
  couponsLeft,
  timeLeftString,
  clickHandler,
  loading,
  offerIsAvailable,
  canGetCodes,
  isMobile,
}: {
  buttonText: string;
  emailLink: string;
  remainingAmount: number;
  couponsLeft: string;
  timeLeftString: string;
  clickHandler: any;
  loading: boolean;
  offerIsAvailable: string;
  canGetCodes: boolean;
  isMobile?: boolean;
}) {
  return (
    <div
      className={`flex col w-full rounded-all-normal p-large gap-large${
        !isMobile ? " card-shadow" : ""
      }`}
    >
      <LoadingButton
        disabled={!canGetCodes}
        loading={loading}
        onClick={clickHandler}
        sx={{
          backgroundColor: "#2496CC",
          color: "#FFFFFF",
          fontFamily: "Cabin",
          fontWeight: 600,
          height: "50px",
          fontSize: "20px",
          borderRadius: "10px",
        }}
      >
        {buttonText}
      </LoadingButton>
      <p className="body-1 text-text-lighten1 text-center">{emailLink}</p>
      <div className="text-primary-lighten2 subtitle-2 text-center">
        {remainingAmount} {couponsLeft}
      </div>
      <div className="body-1 text-text text-center">{offerIsAvailable}</div>
      <h3 className="text-text text-center headline-3">{timeLeftString}</h3>
    </div>
  );
}
